import { Component, OnInit, Input } from '@angular/core';
import { EmployeeRef } from '@akiba/models_bimbo';
import { LogicService } from '../../../services/logic.service';

@Component({
  selector: 'app-employee-ref',
  templateUrl: './employee-ref.component.html',
  styleUrls: ['./employee-ref.component.scss']
})
export class EmployeeRefComponent implements OnInit {

  @Input() disabled: boolean;
  @Input() employeeRef: EmployeeRef;
  constructor() { }

  ngOnInit() {
  }

}
